import { render, staticRenderFns } from "./CornerBox.vue?vue&type=template&id=2f824b27&scoped=true&"
import script from "./CornerBox.vue?vue&type=script&lang=js&"
export * from "./CornerBox.vue?vue&type=script&lang=js&"
import style0 from "./CornerBox.vue?vue&type=style&index=0&id=2f824b27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f824b27",
  null
  
)

export default component.exports